import {MAX_UINT8_ELEMS, MAX_UINT16_ELEMS, MAX_UINT32_ELEMS, bufferType} from "_src/engine/constants";

const arrayPool = [];

export default {

  maxUintArrayValue(typedArray) {

    if (typedArray instanceof Uint32Array) {
      return MAX_UINT32_ELEMS;

    } else if (typedArray instanceof Uint16Array) {
      return MAX_UINT16_ELEMS;

    } else if (typedArray instanceof Uint8Array) {
      return MAX_UINT8_ELEMS;
    }

    return 0;

  },

  uintArrayType(typedArray, elements=1) {

    if (typedArray instanceof Uint32Array) {

      switch (elements) {
        case 3:
          return bufferType.UI32_3;
        case 2:
          return bufferType.UI32_2;
        default:
          return bufferType.UI32_1;
      }

    } else if (typedArray instanceof Uint16Array) {

      switch (elements) {
        case 3:
          return bufferType.UI16_3;
        case 2:
          return bufferType.UI16_2;
        default:
          return bufferType.UI16_1;
      }

    } else if (typedArray instanceof Uint8Array) {

      switch (elements) {
        case 3:
          return bufferType.UI8_3;
        case 2:
          return bufferType.UI8_2;
        default:
          return bufferType.UI8_1;
      }

    }

    return null;

  },

  uintArrayTypeByMaxValue(maxValue) {

    if (maxValue <= MAX_UINT8_ELEMS) {
      return Uint8Array;

    } else if (maxValue <= MAX_UINT16_ELEMS) {
      return Uint16Array;

    } else {
      return Uint32Array;
    }

  },

  createUintArrayByValueLength(maxValue, length) {

    if (maxValue <= MAX_UINT8_ELEMS) {
      return new Uint8Array(length);

    } else if (maxValue <= MAX_UINT16_ELEMS) {
      return new Uint16Array(length);

    } else {
      return new Uint32Array(length);
    }

  },

  createUintArrayByValueData(maxValue, data) {

    if (maxValue <= MAX_UINT8_ELEMS) {
      return new Uint8Array(data);

    } else if (maxValue <= MAX_UINT16_ELEMS) {
      return new Uint16Array(data);

    } else {
      return new Uint32Array(data);
    }

  },

  getArrayBuffer(nbBytes) {

    for (let i = 0; i < arrayPool.length; ++i) {

      if (arrayPool[i].byteLength === nbBytes) {
        return arrayPool.splice(i, 1)[0];
      }

    }

    return new ArrayBuffer(nbBytes);

  },

  returnArrayBuffer(buffer) {
    arrayPool.push(buffer);
  },

  castBuffer : function (buffer, type) {

    switch (type) {
      case bufferType.F32_1:
      case bufferType.F32_2:
      case bufferType.F32_3:
      case bufferType.F32_4:
        return new Float32Array(buffer);
      case bufferType.UI8_1:
      case bufferType.UI8_2:
      case bufferType.UI8_3:
      case bufferType.UI8_4:
        return new Uint8Array(buffer);
      case bufferType.UI16_1:
      case bufferType.UI16_2:
      case bufferType.UI16_3:
        return new Uint16Array(buffer);
      case bufferType.UI32_1:
      case bufferType.UI32_2:
      case bufferType.UI32_3:
        return new Uint32Array(buffer);
      case bufferType.I8_1:
      case bufferType.I8_2:
      case bufferType.I8_3:
        return new Int8Array(buffer);
      case bufferType.I16_1:
      case bufferType.I16_2:
      case bufferType.I16_3:
        return new Int16Array(buffer);
      case bufferType.I32_1:
      case bufferType.I32_2:
      case bufferType.I32_3:
        return new Int32Array(buffer);
      default:
        throw "Unsupported buffer type.";
    }

  },

  getBytesPerElement : function (type) {

    switch (type) {
      case bufferType.F32_1:
      case bufferType.F32_2:
      case bufferType.F32_3:
      case bufferType.F32_4:
        return Float32Array.BYTES_PER_ELEMENT;
      case bufferType.UI8_1:
      case bufferType.UI8_2:
      case bufferType.UI8_3:
      case bufferType.UI8_4:
        return Uint8Array.BYTES_PER_ELEMENT;
      case bufferType.UI16_1:
      case bufferType.UI16_2:
      case bufferType.UI16_3:
        return Uint16Array.BYTES_PER_ELEMENT;
      case bufferType.UI32_1:
      case bufferType.UI32_2:
      case bufferType.UI32_3:
        return Uint32Array.BYTES_PER_ELEMENT;
      case bufferType.I8_1:
      case bufferType.I8_2:
      case bufferType.I8_3:
        return Int8Array.BYTES_PER_ELEMENT;
      case bufferType.I16_1:
      case bufferType.I16_2:
      case bufferType.I16_3:
        return Int16Array.BYTES_PER_ELEMENT;
      case bufferType.I32_1:
      case bufferType.I32_2:
      case bufferType.I32_3:
        return Int32Array.BYTES_PER_ELEMENT;
      default:
        throw "Unsupported buffer type.";
    }

  },

  getNumElements : function (type) {

    switch (type) {
      case bufferType.F32_1:
      case bufferType.UI8_1:
      case bufferType.I8_1:
      case bufferType.UI16_1:
      case bufferType.I16_1:
      case bufferType.UI32_1:
      case bufferType.I32_1:
        return 1;
      case bufferType.F32_2:
      case bufferType.UI8_2:
      case bufferType.I8_2:
      case bufferType.UI16_2:
      case bufferType.I16_2:
      case bufferType.UI32_2:
      case bufferType.I32_2:
        return 2;
      case bufferType.F32_3:
      case bufferType.UI8_3:
      case bufferType.I8_3:
      case bufferType.UI16_3:
      case bufferType.I16_3:
      case bufferType.UI32_3:
      case bufferType.I32_3:
        return 3;
      case bufferType.F32_4:
      case bufferType.UI8_4:
        return 4;
      default:
        throw "Unsupported buffer type.";
    }

  },

  arrayToBitArray(array) {
    const bitArray = new Uint8Array(Math.ceil(array.length/8));

    for (let i = 0; i<array.length; i++) {
      if (array[i] > 0) {
        bitArray[i/8|0] |= 1 << i % 8;
      }
    }

    return bitArray;
  },

  bitArrayToArray(bitArray) {
    const array = new Uint8Array(bitArray.length * 8);

    for (let i=0; i<array.length; i++){
      if ((bitArray[i/8|0] & 1 << i % 8) > 0) {
        array[i] = 1;
      }
    }

    return array;
  },

  shuffle(array) {
    for (let i = array.length - 1; i > 0; --i) {
      const j = Math.floor(Math.random() * (i + 1));
      const x = array[i];
      array[i] = array[j];
      array[j] = x;
    }
    return array;
  }

}
